import React from 'react';
import {PersonOutline} from "@mui/icons-material";
import {InputAdornment, TextField} from "@mui/material";
import T from 'i18n-react';


const CustomerIdInput = ({isError}) => {

    return (
        <TextField
            name={'customerId'}
            type={'text'}
            error={isError}
            InputProps={{
                startAdornment: (
                    <InputAdornment position={'start'}>
                        <PersonOutline/>
                    </InputAdornment>
                )
            }}
            placeholder={T.translate('loginComponent.userName')}
        />
    )

}

export default CustomerIdInput;
